import React from 'react';
import { Component } from '@poa/core';

class CalendarsTableHeader extends React.Component {

  static defaultProps = {
    innerRef: () => {
    }
  };

  render() {
    const { rates, isDashboard } = this.props;

    return (
      <thead
        ref={node => this.props.innerRef(node)}
        onScroll={this.props.onScroll}
        style={{ visibility: this.props.hidden ? 'hidden' : undefined }}
      >
      <tr style={{ color: 'white' }}>
        <th scope='col' style={{backgroundColor: 'rgb(111, 111, 111)'}}></th>
        {rates.weekDays.map((day, idx) => (
          <React.Fragment key={idx}>
            <th style={{
              backgroundColor: (day === 'СБ' || day === 'ВС') ? '#b10303' : 'rgb(111, 111, 111)',
              color: 'white'
            }} scope='col'>{day}</th>
          </React.Fragment>
        ))}
        <th scope='col'>Total</th>
      </tr>
      <tr style={{color: isDashboard ? 'white' : 'black'}}>
        <th scope='col'>Total</th>
        {rates.days.map((day, idx) => (
          <th key={idx} scope='col'>
            {day}
          </th>
        ))}
        <th scope='col'>Total</th>
        <th scope='col'>Plan</th>
      </tr>
      </thead>
    );
  }
}

export default Component({ namespaces: ['calendar2'] })(CalendarsTableHeader);
